import request from '@/utils/request';
import JSONbig from 'json-bigint';
const path = 'project/jrtt';

/** 获取项目列表接口 */
export function getProjectListApi(data) {
  return request({
    url: `/${path}`,
    method: 'get',
    params: data,
    transformResponse: (response) => {
      return JSONbig({ storeAsString: true }).parse(response);
    },
  });
}

/**
 * 获取项目详情接口
 * @param {number} source_id 项目资源ID
 */
export function getProjectInfoApi(source_id) {
  return request({
    url: `/${path}/${source_id}`,
    method: 'get',
    transformResponse: (response) => {
      return JSONbig({ storeAsString: true }).parse(response);
    },
  });
}

/** 创建项目接口 */
export function createProjectApi(data) {
  return request({
    url: `/${path}`,
    method: 'post',
    data,
  });
}

/** 更新项目接口 */
export function updateProjectApi(source_id, data) {
  return request({
    url: `/${path}/${source_id}`,
    method: 'put',
    data,
  });
}

/** 获取项目列表选择器接口 */
export function getProjectSelectorApi(data) {
  return request({
    url: `/${path}/selector`,
    method: 'get',
    params: data,
  });
}

/** 同步项目列表接口 */
export function pullProjectListApi(data) {
  return request({
    url: `/${path}/pull`,
    method: 'get',
    params: data,
  });
}

/**
 * 批量删除项目接口
 * @param {{
 *  source_ids: number[]
 * }} data 参数
 */
export function batchDeleteProjectApi(data) {
  return request({
    url: `/${path}/batchDelete`,
    method: 'post',
    data,
  });
}

/**
 * 批量更新项目状态接口
 * @param {{
 *  source_ids: number[]
 * }} data 参数
 */
export function batchUpdateStatusApi(data) {
  return request({
    url: `/${path}/batchUpdateStatus`,
    method: 'post',
    data,
  });
}
